var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.01,
    fill: "#FFF",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.997c0 .188.072.351.217.489l4.236 4.307a.63.63 0 0 0 .46.207.61.61 0 0 0 .63-.627.66.66 0 0 0-.183-.462l-1.434-1.489-2.457-2.274-.183.365 2.145.138h7.933c.185 0 .337-.06.457-.182s.179-.28.179-.472a.636.636 0 0 0-.18-.466.613.613 0 0 0-.456-.182H9.43l-2.145.13.183.38L9.926 9.57l1.434-1.482a.667.667 0 0 0 .183-.462.61.61 0 0 0-.63-.627.588.588 0 0 0-.243.052.926.926 0 0 0-.237.162l-4.216 4.3a.647.647 0 0 0-.217.483z",
    fill: "#121212",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack1);
export default __webpack_public_path__ + "static/media/icon-back (1).1bb9bc1659119f9b7d8e623c94e5813d.svg";
export { ForwardRef as ReactComponent };